// 配置【不】需要缓存的页面——注意，这里配置的name要和页面的name，以及rms菜单权限配置的页面name一致!!!否则不生效
export const noAliveRouterConfig = [
  // 'RouteView',
  // 'Demand',
  // 'Pre-order-demand' // 预加单
]
